<template>
  <div class="content-box">
    <div class="header" :class="[normalBg]">
      <div class="title">{{ title }}</div>
      <div class="slot-content">
        <!--操作栏-->
        <slot name="header"></slot>
      </div>
    </div>
    <!--内容插槽-->
    <slot name="default"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    normalBg: {
      type: String,
      required: false,
      default: "normal_bg"
    }
  },

}
</script>

<style scoped lang="less">
.content-box {
  width: 100%;
  background: #FAFDFF;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
  border-radius: 0 0 8px 8px;
  border: 2px solid #3490E6;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: inherit;
    height: 40px;

    &.normal_bg {
      background: url("~@/assets/black_imgs/bg_normal.png") no-repeat;
      background-size: 100%;
    }

    &.nikki_bg {
      background: url("~@/assets/black_imgs/nikki_header_bg.png") no-repeat;
      background-size: 100%;
    }

    &.long_bg {
      background: url("~@/assets/black_imgs/bg_mormal_long.png") no-repeat;
      background-size: 100%;
    }

    .title {
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
      margin-left: 30px;
    }
  }
}
</style>
